import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Escaping The Build Trap"
        desc="How Effective Product Management Creates Real Value."
        image="/images/books/escaping-the-build-trap.jpg"
        pageType="book"
        author="Melissa Perri"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/escaping-the-build-trap.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Escaping The Build Trap
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Melissa Perry</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Melissa Perri tackles one of the most common problems in software organizations:
                teams that measure success by how much they ship instead of the value they deliver.
                The "build trap" is the cycle of churning out features without validating whether
                they solve real problems, and this book lays out a clear path to escape it.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                The book covers how to build an effective product management practice, how to align
                strategy with outcomes, and how to create a culture of experimentation over output.
                Whether you are an engineer frustrated by building features nobody uses, a product
                manager trying to shift your team's mindset, or a leader looking to connect strategy
                to execution, this book offers actionable frameworks to focus on what actually matters.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
